import BigNumber from "bignumber.js";

// remainQty/receivedQty from the PO API are always in base uom. A PO line's
// own qty (and the GR qty entered against it) are in the line's own uom, so
// any base-uom quantity must be converted back before comparing/displaying
// alongside them. qtyPerUnitOfMeasure null/0 means no mapping — fall back to
// the raw base-uom value unconverted rather than guessing a rate.
export function convertBaseToLineUom(baseQty, qtyPerUnitOfMeasure) {
  const rate = Number(qtyPerUnitOfMeasure);
  if (!rate || !Number.isFinite(rate)) return Number(baseQty || 0);
  return new BigNumber(baseQty || 0).div(rate).toNumber();
}

// Line display: always pair the qty/uom with its base-uom equivalent, e.g.
// "80(80)" or "ชิ้น(ชิ้น)" — even when they're the same unit. Falls back to
// the raw value alone when there's no base-uom figure to pair it with.
export function formatQtyWithBase(qty, qtyBaseUom) {
  const qtyText = Number(qty || 0).toLocaleString("en-US");
  if (qtyBaseUom == null) return qtyText;
  return `${qtyText}(${Number(qtyBaseUom).toLocaleString("en-US")})`;
}

export function formatUomWithBase(uomName, baseUomName) {
  if (!uomName) return "-";
  if (!baseUomName) return uomName;
  return `${uomName}(${baseUomName})`;
}
